var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("CerrarPlanilla"),
      _vm._v(" "),
      _c("AbrirCerrarPlanillaDetalle"),
      _vm._v(" "),
      _c("VerSeguimientoPlanilla"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("assignment")]),
                  _vm._v("\n        Procesar planillas\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.save.apply(null, arguments)
                    }
                  },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "p-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        {
                          attrs: {
                            wrap: "",
                            row: "",
                            "align-center": "",
                            "justify-space-between": ""
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "number",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label:
                                    "Seleccionar gestión (Solo para procesar planilla)",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.actualizarDatosBotones()
                                  }
                                },
                                model: {
                                  value: _vm.form.gestion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "gestion", _vm._n($$v))
                                  },
                                  expression: "form.gestion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  items: _vm.meses,
                                  "item-value": "id",
                                  "item-text": "valor",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  label:
                                    "Seleccionar mes (Solo para procesar planilla)",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.actualizarDatosBotones()
                                  }
                                },
                                model: {
                                  value: _vm.form.mes,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "mes", $$v)
                                  },
                                  expression: "form.mes"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "py-0", attrs: { xs12: "" } },
                            [
                              _c("v-autocomplete", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  items: _vm.unidades_especificas,
                                  "item-value": "id_unidad",
                                  "item-text": "nombre_unidad",
                                  label: "Dependencia (Para procesar planilla)",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.validarBotonProcesarPLanillaPorUnidad()
                                  }
                                },
                                model: {
                                  value: _vm.form.id_unidad_especifica,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "id_unidad_especifica",
                                      $$v
                                    )
                                  },
                                  expression: "form.id_unidad_especifica"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "py-0 pr-0",
                              attrs: { xs12: "", md4: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "#0076A8",
                                    loading: _vm.loading,
                                    title: "Procesar planilla ASP-B",
                                    dark: "",
                                    block: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.procesarPlanillaMEFP()
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("schedule")]),
                                  _vm._v(
                                    "PROCESAR PLANILLA ASP-B\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-center p-0",
                              attrs: { xs12: "", md4: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "rgb(252, 76, 2,0.9)",
                                    loading: _vm.loading,
                                    title: "Cerrar proceso de planilla mensual",
                                    dark: "",
                                    block: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.cerrarProcesoPlanilla()
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("lock")]),
                                  _vm._v(
                                    "CERRAR PROCESO DE PLANILLA MENSUAL\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "py-0 pl-0",
                              attrs: { xs12: "", md4: "" }
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "#0076A8",
                                    loading: _vm.loading_unidad,
                                    title: "Procesar planilla por dependencia",
                                    dark: "",
                                    block: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.procesarPlanillaPorUnidad()
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("schedule")]),
                                  _vm._v(
                                    "PROCESAR PLANILLA POR DEPENDENCIA\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "py-0",
                              attrs: { xs12: "", sm6: "", md4: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Paterno",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.filtraFuncionarios()
                                  }
                                },
                                model: {
                                  value: _vm.form.paterno,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "paterno", $$v)
                                  },
                                  expression: "form.paterno"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "py-0",
                              attrs: { xs12: "", sm6: "", md4: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Materno",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.filtraFuncionarios()
                                  }
                                },
                                model: {
                                  value: _vm.form.materno,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "materno", $$v)
                                  },
                                  expression: "form.materno"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "py-0",
                              attrs: { xs12: "", sm6: "", md4: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Nombres",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.filtraFuncionarios()
                                  }
                                },
                                model: {
                                  value: _vm.form.nombres,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nombres", $$v)
                                  },
                                  expression: "form.nombres"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "py-0",
                              attrs: { xs12: "", sm6: "", md4: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Cédula de identidad",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.filtraFuncionarios()
                                  }
                                },
                                model: {
                                  value: _vm.form.ci,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "ci", $$v)
                                  },
                                  expression: "form.ci"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "py-0",
                              attrs: { xs12: "", sm6: "", md4: "" }
                            },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  label: "Item",
                                  outline: "",
                                  clearable: "",
                                  success: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.filtraFuncionarios()
                                  }
                                },
                                model: {
                                  value: _vm.form.item,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "item", $$v)
                                  },
                                  expression: "form.item"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            disabled: !_vm.bandera_boton_buscar,
                            color: "rgba(31,14,180,0.7)",
                            type: "submit",
                            dark: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.filtraFuncionarios()
                            }
                          }
                        },
                        [
                          _c("v-icon", [_vm._v("search")]),
                          _vm._v("\n            Buscar\n          ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "#90237b", type: "submit", dark: "" },
                          on: {
                            click: function($event) {
                              return _vm.limpiarCampos()
                            }
                          }
                        },
                        [
                          _c("v-icon", [_vm._v("redo")]),
                          _vm._v("\n            Limpiar\n          ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lista_filtrada_funcionarios,
                  "no-data-text": _vm.loading
                    ? "Cargando..."
                    : "No se tiene registros",
                  loading: _vm.loading,
                  "item-key": "index",
                  "rows-per-page-text": "Filas por pagina",
                  pagination: _vm.pagination,
                  "rows-per-page-items": [
                    5,
                    10,
                    20,
                    50,
                    { value: -1, text: "Todos" }
                  ]
                },
                on: {
                  "update:pagination": function($event) {
                    _vm.pagination = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "headers",
                    fn: function(props) {
                      return [
                        _c(
                          "tr",
                          _vm._l(props.headers, function(header) {
                            return _c(
                              "th",
                              {
                                key: header.text,
                                staticClass: "header-comprmido",
                                class: [
                                  "column sortable",
                                  _vm.pagination.descending ? "desc" : "asc",
                                  header.value === _vm.pagination.sortBy
                                    ? "active"
                                    : ""
                                ],
                                attrs: { id: "cabecera_tabla" },
                                on: {
                                  click: function($event) {
                                    return _vm.changeSort(header.value)
                                  }
                                }
                              },
                              [
                                header.value
                                  ? _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "white" } },
                                      [_vm._v("arrow_upward")]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(header.text) +
                                    "\n            "
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ]
                    }
                  },
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c(
                          "td",
                          { staticClass: "text-xs-center py-0 px-1" },
                          [
                            _c(
                              "v-avatar",
                              {
                                attrs: {
                                  color: props.item.foto
                                    ? "#FFF"
                                    : "light-blue darken-4"
                                }
                              },
                              [
                                props.item.foto
                                  ? _c("img", {
                                      staticStyle: {
                                        border: "1px solid #7BAFD4 !important"
                                      },
                                      attrs: {
                                        src: _vm.url_backend + props.item.foto,
                                        alt: props.item.nombres[0]
                                      },
                                      on: {
                                        error: function($event) {
                                          return _vm.handleImageError(
                                            props.item
                                          )
                                        }
                                      }
                                    })
                                  : _c(
                                      "span",
                                      { staticClass: "white--text headline" },
                                      [
                                        _vm._v(
                                          _vm._s(props.item.nombres[0] || "-")
                                        )
                                      ]
                                    )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center py-0 px-1" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nro_item) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center py-0 px-1" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nombres) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center py-0 px-1" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.ap_paterno) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center py-0 px-1" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.ap_materno) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center py-0 px-1" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.nro_doc) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center py-0 px-1" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.dependencia) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center py-0 px-1" },
                          [
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  dark: "",
                                  small: "",
                                  color: props.item.cerrado
                                    ? "#DF4661"
                                    : "#6CC24A"
                                }
                              },
                              [
                                _c("v-icon", [
                                  _vm._v(
                                    _vm._s(
                                      props.item.cerrado ? "lock" : "lock_open"
                                    ) + " "
                                  )
                                ]),
                                _vm._v(
                                  _vm._s(
                                    props.item.cerrado ? "CERRADO" : "ABIERTO"
                                  )
                                )
                              ],
                              1
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            " +
                                _vm._s(props.item.mes) +
                                "-" +
                                _vm._s(props.item.gestion) +
                                "\n          "
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center py-0 px-1" },
                          [
                            props.item.mes && props.item.gestion
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#CE0037",
                                      dark: "",
                                      icon: "",
                                      title: props.item.cerrado
                                        ? "Abrir planilla detalle"
                                        : "Cerrar planilla detalle"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.abreCierraPlanillaDetalle(
                                          props.item
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v(
                                        _vm._s(
                                          props.item.cerrado
                                            ? "lock_open"
                                            : "lock"
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            props.item.mes && props.item.gestion
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "blue",
                                      dark: "",
                                      icon: "",
                                      outline: "",
                                      title: "Ver seguimiento"
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.verSeguimiento(props.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("visibility")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !props.item.cerrado
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "#F58736",
                                      dark: "",
                                      icon: "",
                                      outline: "",
                                      title: "Procesar planilla",
                                      loading: props.item.loading == true
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.procesarPlanillaPorFuncionario(
                                          props.item
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("schedule")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "#0076A8",
                                  dark: "",
                                  icon: "",
                                  outline: "",
                                  title: "Ver detalle refrigerio",
                                  to:
                                    "/detalle-refrigerio/" +
                                    props.item.id_persona +
                                    "/" +
                                    _vm.form.mes +
                                    "/" +
                                    _vm.form.gestion
                                }
                              },
                              [_c("v-icon", [_vm._v("shopping_cart")])],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-692ae466", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-692ae466","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asistencia/Planillas.vue
// module id = null
// module chunks = 